import React, {useState} from "react";
import "./DocumentSharedDatePicker.css";
import {Banner, Button} from "@shopify/polaris";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {DateSelector} from "../DateSelector/DateSelector";
import {isPastDate} from "../../helpers/dates";
import {updateGlobalExpiryDate} from "../../store/actions/Inspections";
import {PortalState} from "../../types/PortalState";
import styles from "../Sections/Sections.module.css";
import SurveyorCompletionStatus from "../../types/SurveyorCompletionStatus";
import {DocumentReuseStatus} from "../../types/Inspection";

export default function DocumentSharedDatePicker() {
    const {t} = useTranslation("common");
    const [expiryDateTime, setExpiryDateTime] = useState<string | undefined>(undefined);
    const [dateError, setDateError] = useState<string | undefined>();
    const [dateValid, setDateValid] = useState<boolean>(false);
    const dispatch = useDispatch();

    const [bannerVisible, setBannerVisible] = useState<boolean>(true);

    const surveyorCompletionStatus: SurveyorCompletionStatus | undefined =
        useSelector(
            (state: PortalState) =>
                state.portal.activeInspection?.SurveyorCompletionStatus
        );

    const reUseStatus = useSelector(
        (state: PortalState) => {
            return state.portal.activeInspection?.DocumentReuseStatus
        }
    );

    const currentInspection = useSelector(
        (state: PortalState) => state.portal.activeInspection
    );

    const inspectionTypeAllowedReuse = useSelector((state: PortalState) => {return state.portal.activeInspection?.inspectionTypeAllowedReuse});


    const handleSharedDateSubmit = async () => {
        dispatch(updateGlobalExpiryDate(expiryDateTime as string));
    }

    const elementsInReuseState = currentInspection?.sections.some((section) => (
        section.ReUseDocuments === true
    ))


    if (!inspectionTypeAllowedReuse || reUseStatus == null || reUseStatus == DocumentReuseStatus.NOT_SELECTED || surveyorCompletionStatus?.DocumentsComplete) {
        return null;
    }

    const banner = () => {
        if(!bannerVisible){
            return null;
        }

        if (elementsInReuseState) {
            return (
                <Banner onDismiss={() => {
                    setBannerVisible(false)
                }}>
                    <div className={"re-use-title"}>{t("documentSharedDatePicker.title")}</div>
                    <div className={"date-card-title"}>
                        {t("documentSharedDatePicker.hintText")}
                    </div>
                    <div className="dates">
                        <div className="date-fields">
                            <DateSelector
                                dateValue={undefined}
                                dateError={null}
                                disabled={false}
                                onChange={
                                    (event) => {

                                        if (isPastDate(event.target.value)) {
                                            setDateError(t("documentSharedDatePicker.error"));
                                            setDateValid(false);
                                            return;
                                        }

                                        setDateError(undefined);
                                        setDateValid(true);
                                        setExpiryDateTime(event.target.value);
                                    }}
                            />
                        </div>
                        <div className="submit-section">
                            <Button submit size="large" onClick={handleSharedDateSubmit}
                                    disabled={!dateValid}>{t("documentSharedDatePicker.submit")}</Button>
                        </div>
                    </div>
                    {dateError && <div className="error-message"><p className="error">{dateError}</p></div>}
                </Banner>
            )
        }
    }

    return (

        <div className={styles.surveyorNotesContainer}>
            {banner()}
        </div>

    )
}